import { render, staticRenderFns } from "./table-released.vue?vue&type=template&id=420b69bd&scoped=true&"
import script from "./table-released.vue?vue&type=script&lang=js&"
export * from "./table-released.vue?vue&type=script&lang=js&"
import style0 from "./table-released.vue?vue&type=style&index=0&id=420b69bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420b69bd",
  null
  
)

export default component.exports